import React, { useState } from "react";
import { supabase } from "../lib/supabase";
import toast from "react-hot-toast";

const UpdatePassword = () => {
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [loading, setLoading] = useState(false);

	const handlePasswordUpdate = async (e) => {
		e.preventDefault();

		if (newPassword !== confirmPassword) {
			toast.error("Passwords do not match.");
			return;
		}

		setLoading(true);
		const toastId = toast.loading("Updating password...");

		try {
			const { error } = await supabase.auth.updateUser({
				password: newPassword,
			});

			if (error) {
				toast.error("Failed to update password: " + error.message, {
					id: toastId,
				});
				console.error(error);
			} else {
				toast.success("Password updated successfully.", {
					id: toastId,
				});
				setNewPassword("");
				setConfirmPassword("");
			}
		} catch (err) {
			toast.error("An error occurred while updating your password.", {
				id: toastId,
			});
			console.error("Error updating password:", err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="main">
			<div className="update-password__wrapper">
				<h1>Update Password</h1>
				<form onSubmit={handlePasswordUpdate}>
					<div className="update-password__row">
						<label htmlFor="newPassword">New Password</label>
						<input
							type="password"
							id="newPassword"
							value={newPassword}
							onChange={(e) => setNewPassword(e.target.value)}
							required
						/>
					</div>
					<div className="update-password__row">
						<label htmlFor="confirmPassword">
							Confirm Password
						</label>
						<input
							type="password"
							id="confirmPassword"
							value={confirmPassword}
							onChange={(e) => setConfirmPassword(e.target.value)}
							required
						/>
					</div>
					<button
						type="submit"
						disabled={loading}
						className="button green"
					>
						{loading ? "Updating..." : "Update Password"}
					</button>
				</form>
			</div>
		</div>
	);
};

export default UpdatePassword;
